import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import TeamSurveyCardContainer from "../containers/TeamSurveyCardContainer";
import Slider from "../components/Slider";
import DeleteDialog from "../components/DeleteDialog";
import teams_api from "../api/protected/teams";
import people_api from "../api/protected/people";
import deleteIcon from "../assets/delete-icon.svg"
import back_arrow from "../assets/backarrow.svg";
import GenericDialog from "../components/GenericDialog";
import EditTeamDetailsContainer from "../components/EditTeamDetailsContainer";
import EditTeamMembersContainer from "../components/EditTeamMembersContainer";
import EditTeamLatestSurveyContainer from "../components/EditTeamLatestSurveyContainer";
import EditTeamPreviousSurveysContainer from "../components/EditTeamPreviousSurveysContainer";
import EditTeamPerformanceContainer from "../components/EditTeamPerformanceContainer";
import EditTeamFeedbackContainer from "../components/EditTeamFeedbackContainer";
import Select from "react-select";
import styles from "../utils/ReactSelectStyles";
import comparison_api from "../api/protected/comparison";
import expand from "../assets/expand-teams.svg";
import collapse from "../assets/collapse.svg";


const EditTeam = () => {
    const navigate = useNavigate()
    const params = useParams();
    const [parameters, setParameters] = useSearchParams();

    const [teamId, setTeamId] = useState("")
    const [isDemo, setIsDemo] = useState(false)
    const [team, setTeam] = useState(null)
    const [teamName, setTeamName] = useState("");
    const [organisationName, setOrganisationName] = useState("")
    const [teamDescription, setTeamDescription] = useState("");
    const [organisationId, setOrganisationId] = useState();
    const [countryCode, setCountryCode] = useState("");
    const [categoryId, setCategoryId] = useState(null);
    const [editor, setEditor] = useState(false)
    const [people, setPeople] = useState([]);

    const [showDelete, setShowDelete] = useState();
    const buttons = [{"text":"Delete", "id": "1"}, {"text":"Cancel", "id": "2"}];
    const [showDeleteHover, setShowDeleteHover] = useState(false)
    const [showHidden, setShowHidden] = useState()
    const [deletedPeople, setDeletedPeople] = useState([])
    const [showError, setShowError] = useState(false)
    const errorButtons = [{"text":"OK", "id": "1"}];
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [triggerUpdate, setTriggerUpdate] = useState(false)
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false)
    const subscriptionPopupButtons = [{"text":"OK", "id": "1"}, {"text":"Upgrade", "id": "2"}];
    const [errorText, setErrorText] = useState("");

    const [showComparisonPopup, setShowComparisonPopup] = useState(false)
    const [comparisonSurveys, setComparisonSurveys] = useState([])
    const [firstComparison, setFirstComparison] = useState()
    const [secondComparison, setSecondComparison] = useState()
    const [showInsufficientOverlap, setShowInsufficientOverlap] = useState(false)

    const [detailsCollapsed, setDetailsCollapsed] = useState(true)


    useEffect(() => {
        if (!params.teamId) return;
        setTeamId(params.teamId)
    }, [params.teamId]);

    useEffect(() => {
        const demoParam = parameters.get("demo");
        if (demoParam === "true") {
            setIsDemo(true);
        }
    }, [parameters]);

    useEffect(() => {
        if (!teamId) return;
        getTeam()
        getPeople();
        getComparisonSurveys()
    }, [teamId]);

    const getTeam = () => {
        if (!teamId) return;
        if(isDemo) {
            let response = teams_api.getDemoTeamByID(teamId);
            response.then(response => {
                if (response.data.teams === []) BackButton()
                else {
                    let data = response.data.teams[0]
                    setTeam(data);
                    setTeamName(data.name);
                    setOrganisationName(data.organisation_name)
                    setTeamDescription(data.description);
                    setOrganisationId(data.organisation_id);
                    setCountryCode(data.country)
                    setCategoryId(data.category_id ?? null)
                    setShowHidden(false);
                    setEditor(false);
                }
            })
        } else {
            let response = teams_api.getTeamByID(teamId);
            response.then(response => {
                if (response.data.teams.length === 0) BackButton()
                else {
                    let data = response.data.teams[0]
                    setTeam(data);
                    setTeamName(data.name);
                    setOrganisationName(data.organisation_name)
                    setTeamDescription(data.description);
                    setOrganisationId(data.organisation_id);
                    setCountryCode(data.country)
                    setCategoryId(data.category_id ?? null)
                    setShowHidden(data.hidden);
                    setEditor(data.editor);
                }
            })
        }
    }

    const getPeople = () => {
        if (!teamId) return;
        let response;
        if(isDemo) {
            response = people_api.getDemoPeople(teamId);
        } else {
            response = people_api.getPeople(teamId);
        }
        response.then(
            response => {
                setPeople(response.data.people);
            }
        )
    }

    const newPerson = (person) => {
        if(!person) return;
        let temp = [...people]
        temp.push(person)
        setPeople(temp)
        setTriggerUpdate(true)
    }

    const deletePerson = (ev, idx) => {
        let dp = [...deletedPeople]
        let temp = [...people]

        if (temp[idx].id !== "new") dp.push(temp[idx].id)
        temp.splice(idx, 1)

        setDeletedPeople(dp)
        setPeople(temp)
        setTriggerUpdate(true)
    }

    const updatePerson = (person, idx) => {
        let temp = [...people]
        temp[idx] = person
        setPeople(temp)
        setTriggerUpdate(true)
    }

    useEffect(() => {
        if(!triggerUpdate) return;
        savePeopleUpdates()
        setTriggerUpdate(false)
    }, [triggerUpdate])

    const savePeopleUpdates = () => {
        let response = people_api.updatePeople(teamId, organisationId, people, deletedPeople)
        response.then(() => {
            getPeople()
            setTriggerUpdate(false)
        }).catch(err => {
            if (err.response.request.status === 402) {
                setShowSubscriptionPopup(true)
            } else {
                setErrorText(err.response.data.description)
                triggerErrorMessage()
            }
        })
    }

    const triggerErrorMessage = () => {
        setShowConfirmation(false);
        setShowError(true);
    }

    const handleDeleteClick = () => {
        setShowDelete(!showDelete)
    }

    const handleDeleteResult = (result) => {
        if (!editor) return;
        if (result === "1") {
            deleteTeam()
        }
        setShowDelete(false)
    }

    const handleErrorResult = (result) => {
        if (result === "1") {
            setShowError(false);
            window.location.reload()
        }
    }

    const handleConfirmationResult = (result) => {
        if(result === "1") {
            setShowConfirmation(false);
            window.location.reload()
        }
    }

    const deleteTeam = () => {
        if(!teamId || !editor) return;
        let response = teams_api.deleteTeam(teamId)
        response.then(() => {
            navigate("/teams")
        }).catch(err => console.log(err))
    }

    const formSubmit = (body) => {
        if (!body || !editor) return;
        if (body.hasOwnProperty("organisation_id")) delete body["organisation_id"]
        let response = teams_api.updateTeam(teamId, body);
        response.then(() => {
            navigate("/teams")
        }).catch(err => console.log(err))
    }

    const BackButton = () => {
        if (window.history.length > 1) {
            navigate(-1)
        }
        else {
            navigate("/teams")
        }
    }

    const updateToggleHidden = () => {
        setShowHidden(!showHidden);
    }

    const handleDeleteHoverOn = () => {
        setShowDeleteHover(true)
    }

    const handleDeleteHoverOut = () => {
        setShowDeleteHover(false)
    }

    useEffect(() => {
        if (!editor) return;
        const body = {"hidden": showHidden}
        let response = teams_api.putTeamVisibility(teamId, body);
        response.catch(
            err => {
                console.log(err)
            }
        )
    }, [showHidden]);

    const handleSubscriptionPopupResult = (res) => {
        if(!res) return;
        if (res === "1") {
            setShowSubscriptionPopup(false)
        } else {
            navigate("/pricing-plans")
        }
    }

    const getComparisonSurveys = () => {
        if (!teamId) return;
        let response = comparison_api.getComparableSurveys(teamId, isDemo);
        response.then(res => {
            setComparisonSurveys(res.data.surveys);
        }).catch(err => console.log(err));
    };

    const handleComparisonChange = (ev, selector) => {
        if (!ev || !selector) return;
        let _comparisons = [...comparisonSurveys]
        let _idx = _comparisons.indexOf(ev)
        _comparisons.splice(_idx, 1)
        switch(selector) {
            case "first":
                if (firstComparison) _comparisons.push(firstComparison)
                setFirstComparison(ev)
                break;
            case "second":
                if (secondComparison) _comparisons.push(secondComparison)
                setSecondComparison(ev)
                break;
        }
        _comparisons.sort((a, b) => a.id - b.id);
        setComparisonSurveys(_comparisons)
    }

    const handleComparisonSubmit = () => {
        if (!firstComparison || !secondComparison) return;
        const comparisonPath = `/diagnostic_engagement/${firstComparison.id}/${secondComparison.id}?demo=${isDemo}`
        comparison_api.getComparisonOverlap(firstComparison.id, secondComparison.id, isDemo)
            .then((res) => {
                if ((res.data.common_participants ?? 0) < 2) {
                    setShowInsufficientOverlap(true)
                    return
                }
                navigate(comparisonPath)
            })
            .catch((err) => {
                if (comparison_api.isInsufficientCommonParticipants(err)) {
                    setShowInsufficientOverlap(true)
                    return
                }
                navigate(comparisonPath)
            })
    }

    const handleDetailsCollapse = (ev) => {
        if(!ev) return;
        setDetailsCollapsed(!detailsCollapsed)
    }

    return (
        <div className="teams-page-background-container">
            <div className="teams-page-container">
                <div className="back-link link" onClick={() => BackButton()}>
                    <img className={"back-arrow-classname"}  src={back_arrow} alt={"Back Arrow"}/>
                </div>
                {team && team ?
                    <>
                        <div className="teams-page-header">
                            <div className="teams-page-title dual-title">
                                <div className="teams-page-fixed-title">Team Page</div>
                                {teamName ? `${teamName}, ${organisationName}` : "Edit Team"}
                            </div>
                            {editor ?
                                <div className="team-page-controls">
                                    <div className="header-icon-container">
                                        {editor ?
                                            <div className="header-slider-container">
                                                <Slider update={updateToggleHidden.bind(this)} state={showHidden} type="Team"/>
                                                <div className="header-hide-text">Hide</div>
                                            </div> : null
                                        }
                                        <div className="header-delete-container"
                                             onMouseOver={handleDeleteHoverOn}
                                             onClick={handleDeleteClick}
                                             onMouseLeave={handleDeleteHoverOut}>
                                            <img className="header-delete-icon link" src={deleteIcon} alt="Delete Team"/>
                                            {showDeleteHover ?
                                                <div className="delete-tooltip-container">
                                                    <div className="delete-tooltip-text">Delete Team</div>
                                                </div> : null
                                            }
                                        </div>
                                    </div>
                                </div>
                                :null}
                        </div>
                        <EditTeamDetailsContainer name={teamName} description={teamDescription} team={team} country={countryCode}
                                                  categoryId={categoryId}
                                                  editor={editor} submit={formSubmit.bind(this)}
                                                  organisationId={organisationId} isDemo={isDemo}/>
                        <EditTeamMembersContainer people={people} deletePerson={deletePerson.bind(this)}
                                                  updatePerson={updatePerson.bind(this)}
                                                  newPerson={newPerson.bind(this)} isDemo={isDemo}/>
                        <div className="edit-team-survey-cards-container">
                            <div className="edit-team-survey-card-title-container">
                                <div className="teams-form-title">
                                    Survey Overview
                                </div>
                                <div className={`edit-team-previous-survey-collapse ${detailsCollapsed ? "collapsed" : ""}`} onClick={handleDetailsCollapse}>
                                    <img src={detailsCollapsed ? expand : collapse} alt={detailsCollapsed ? "Show survey details" : "Hide survey details"}/>
                                </div>
                            </div>
                            {!detailsCollapsed ?
                                <TeamSurveyCardContainer teamId={teamId} editor={editor} organisationId={organisationId}
                                                     isDemo={isDemo}/>
                                : null
                            }
                        </div>
                        <EditTeamLatestSurveyContainer team_id={teamId} isDemo={isDemo}/>
                        <EditTeamPreviousSurveysContainer team_id={teamId} isDemo={isDemo}/>
                        <EditTeamPerformanceContainer team_id={teamId} isDemo={isDemo} setShowComparisonPopup={setShowComparisonPopup.bind(this)}/>
                        <EditTeamFeedbackContainer team_id={teamId} isDemo={isDemo}/>

                    </> : null}
                {showDelete ?
                    <DeleteDialog title={"Delete Team"}
                                  type={"Team"}
                                  name={teamName && teamName}
                                  description={teamDescription && teamDescription}
                                  buttons={buttons}
                                  result={handleDeleteResult.bind(this)}/>
                    :null
                }
                {showError ?
                    <GenericDialog title="Update Failed"
                                   text={errorText}
                                   buttons={errorButtons}
                                   result={handleErrorResult.bind(this)}/>
                    :null
                }
                {showConfirmation ?
                    <GenericDialog title="Update Successful"
                                   text="Team people updated."
                                   buttons={errorButtons}
                                   result={handleConfirmationResult.bind(this)}/>
                    :null
                }
                {showSubscriptionPopup ?
                    <GenericDialog title="Stakeholder Limit Reached"
                                   text="You have reached the limit of team stakeholders for your subscription. Please upgrade if you wish to add more"
                                   buttons={subscriptionPopupButtons}
                                   result={handleSubscriptionPopupResult.bind(this)}/>
                    : null
                }
                {showComparisonPopup ?
                    <>
                        <div className="page-mask"/>
                        <div className="comparison-popup-container">
                            <div className="dialog-header-container">
                                <div className="comparison-popup-header">Select surveys to compare</div>
                            </div>
                            <div className="summary-comparison-dropdown-container comparison">
                                <Select name="traits.organisation_role" options={comparisonSurveys}
                                        getOptionLabel={option => option.name} getOptionValue={option => option.id}
                                        value={firstComparison} placeholder="" onChange={ev => handleComparisonChange(ev, "first")}
                                        styles={styles.registerStyles} required={false}
                                />
                            </div>
                            <div className="summary-comparison-dropdown-container comparison">
                                <Select name="traits.organisation_role" options={comparisonSurveys}
                                        getOptionLabel={option => option.name} getOptionValue={option => option.id}
                                        value={secondComparison} placeholder="" onChange={ev => handleComparisonChange(ev, "second")}
                                        styles={styles.registerStyles} required={false}
                                />
                            </div>
                            <div className="dialog-footer-container">
                                <div className="dialog-button link" onClick={() => {
                                    setFirstComparison()
                                    setSecondComparison()
                                    setShowComparisonPopup(false)
                                }}>
                                    <div className="dialog-button-text">Cancel</div>
                                </div>
                                <div className={firstComparison && secondComparison ? "dialog-button link" : "dialog-button disabled"} onClick={() => handleComparisonSubmit()}>
                                    <div className="dialog-button-text">Compare</div>
                                </div>
                            </div>
                        </div>
                    </>
                :null}
                {showInsufficientOverlap ?
                    <GenericDialog title="Comparison Summary"
                                   text={comparison_api.INSUFFICIENT_COMMON_PARTICIPANTS_MESSAGE}
                                   buttons={[{"text": "OK", "id": "1"}]}
                                   result={() => setShowInsufficientOverlap(false)}/>
                    : null
                }
            </div>
        </div>
    )
}

export default EditTeam